import { useMutation } from "@tanstack/react-query";

import { ContactRequestProperties } from "@seneca/tutoring-service-types";

import { getClient, queryClient } from "services";

import { FETCH_LEAD_QUERY_KEY } from "../consts";

const QUERY_KEY = "tutoring-leads-form-create";

const createContact = async (contactProperties: ContactRequestProperties) =>
  getClient("tutoringService").createContact(contactProperties);

export function useCreateContact({ onSuccess }: { onSuccess?: () => void }) {
  return useMutation({
    mutationKey: [QUERY_KEY],
    mutationFn: createContact,
    onSuccess: () => {
      onSuccess && onSuccess();
      queryClient.refetchQueries({ queryKey: [FETCH_LEAD_QUERY_KEY] });
    }
  });
}
